import { Platform } from "react-native";

const SHARED_COLLECTION_PATH_RE = /^\/(?:webapp\/)?sharedcollection(?:\/|$)/;

export const isSharedCollectionEntry = (): boolean => {
  if (Platform.OS !== "web" || typeof window === "undefined") return false;
  return SHARED_COLLECTION_PATH_RE.test(window.location?.pathname ?? "");
};

export default isSharedCollectionEntry;
